import React, { useEffect } from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { AboutSection } from '../components/about/AboutSection';
import { useAppStore } from '../store/useAppStore';

export const About: React.FC = () => {
  useEffect(() => {
    useAppStore.getState().setHasVisitedAbout(true);
  }, []);

  return (
    <div className="flex min-h-dvh flex-col bg-[#f7f7f7]">
      <Header />
      <main className="flex min-h-0 flex-1 flex-col">
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
};
